module.exports = __webpack_public_path__ + "static/media/use-flag.4c3d08c6.svg";